import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { RadioButton } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import ReactModalHeader from '../Modal/ReactModalHeader';
import ReactModalContent from '../Modal/ReactModalContent';
import ReactModalFooter from '../Modal/ReactModalFooter';
import { chartsActions, modalActions } from '../../redux/root-action';
import { modals, chartTypes, charts, showAsOptionsMobile, dollarTypeOptionsMobile } from '../../utils/constants';

const StyledCategoryContainer = styled.div`
  margin-top: 32px;
  > div > div {
    display: block;
    > div {
      margin-bottom: 16px;
    }
    label {
      font-family: Nimbus Sans Regular;
      font-weight: normal;
    }
  }
`;

const StyledCategoryHeader = styled.div`
  font-family: Nimbus Sans Bold;
  font-size: 16px;
  line-height: 22px;
  color: ${tokens.ColorGrey900};
  margin-bottom: 16px;
`;

const StyledFootnote = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 12px;
  line-height: 18px;
  color: ${tokens.ColorGrey600};
  margin-top: 28px;
`;

class EditChartDisplaySettings extends Component<any, any> {
  handleOptionChange = (option: any) => {
    const { simulationCurrentWant, simulationCurrentHave, selectChartType, fetchSimulationCurrentHave } = this.props;
    selectChartType(option.value);
    if (option.value === chartTypes.HAVE && !simulationCurrentHave.simulationType) {
      fetchSimulationCurrentHave(simulationCurrentWant.mStarRequestId);
    }
  };

  SaveSettings = () => {
    const { hideModal } = this.props;
    hideModal(modals.EDIT_CHART_DISPLAY_SETTINGS);
  };

  handleDollarTypeChange = (option: any) => {
    const { selectDollarType } = this.props;
    selectDollarType(option);
  };

  render(): JSX.Element {
    const {
      retirementShowAs,
      toggleRetirementShowAs,
      selectedChart,
      selectedChartType,
      selectedDollarType = { name: "Show in today's dollars", value: 'todaysDollars' },
    } = this.props;
    const selectedChartTypeOption = [
      { label: 'Live on your income goal', value: chartTypes.WANT },
      { label: 'Make Your Savings Last', value: chartTypes.HAVE },
    ].filter(option => option.value === selectedChartType)[0];

    return (
      <React.Fragment>
        <ReactModalHeader modalTitle={'Edit Chart Display Settings'} showClose={false} />
        <ReactModalContent>
          <StyledCategoryContainer>
            <StyledCategoryHeader>Spending</StyledCategoryHeader>
            <RadioButton
              name="chartType"
              options={[
                { label: 'Live on your income goal', value: chartTypes.WANT },
                { label: 'Make your savings last', value: chartTypes.HAVE },
              ]}
              selectedOption={selectedChartTypeOption}
              onChange={(option: any) => this.handleOptionChange(option)}
            />
          </StyledCategoryContainer>
          {selectedChart.id === charts.RETIREMENT_INCOME && (
            <>
              <StyledCategoryContainer>
                <StyledCategoryHeader>Dollar Value* </StyledCategoryHeader>
                <RadioButton
                  name="dollarType"
                  options={dollarTypeOptionsMobile}
                  selectedOption={selectedDollarType}
                  onChange={(option: any) => this.handleDollarTypeChange(option)}
                />
              </StyledCategoryContainer>
              <StyledCategoryContainer>
                <StyledCategoryHeader>Show Income As</StyledCategoryHeader>
                <RadioButton
                  name="incomeToggle"
                  options={showAsOptionsMobile}
                  selectedOption={retirementShowAs}
                  onChange={(option: any) => toggleRetirementShowAs(option)}
                />
              </StyledCategoryContainer>
              <StyledFootnote>
                *Today’s dollars and future dollars are different ways of illustrating the value of money over time.
                <br />
                <br />
                Today’s dollars describe how much a projected amount in the future is worth today, including assumptions
                about growth and inflation. In calculating today’s dollars, we discount inflation growth to illustrate
                the current value of future dollars.
                <br />
                <br />
                Future dollars describe projected growth over time, including projected inflation.
              </StyledFootnote>
            </>
          )}
        </ReactModalContent>
        <ReactModalFooter CTAButtonText="Save Settings" handleCTAClick={this.SaveSettings} hideCancel={true} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  charts: {
    selectedChart,
    selectedChartType,
    retirementShowAs,
    selectedDollarType,
    simulationCurrentHave,
    simulationCurrentWant,
  },
}: any) => {
  return {
    selectedChart,
    selectedChartType,
    retirementShowAs,
    selectedDollarType,
    simulationCurrentHave,
    simulationCurrentWant,
  };
};

export default connect(mapStateToProps, {
  toggleRetirementShowAs: chartsActions.toggleRetirementShowAs,
  selectChartType: chartsActions.selectChartType,
  selectDollarType: chartsActions.selectDollarType,
  showModal: modalActions.showModal,
  hideModal: modalActions.hideModal,
  selectAge: chartsActions.selectAge,
  fetchSimulationCurrentHave: chartsActions.fetchSimulationCurrentHave,
})(EditChartDisplaySettings);
